function formatDateRange(start, end) {
  var startMonth = start.toLocaleString('en-us', { month: 'short' });
  var endMonth = end.toLocaleString('en-us', { month: 'short' });

  var startDate = start.getDate();
  var endDate = end.getDate();

  if (startMonth === endMonth) {
    return startMonth + ' ' + startDate + ' - ' + endDate;
  } else {
    return startMonth + ' ' + startDate + ' - ' + endMonth + ' ' + endDate;
  }
}

const date = new Date();
const today = date.getDate();
const month = date.toLocaleString('en-us', { month: 'short' });

const soonestShippingDays =
  document.getElementById('soonest-shipping').textContent;
const latestShippingDays =
  document.getElementById('latest-shipping').textContent;

const soonestShipping = new Date();
const latestShipping = new Date();

const soonestDelivery = new Date();
const latestDelivery = new Date();

soonestShipping.setDate(
  soonestShipping.getDate() + Number(soonestShippingDays)
);
latestShipping.setDate(latestShipping.getDate() + Number(latestShippingDays));

soonestDelivery.setDate(
  soonestDelivery.getDate() + Number(soonestShippingDays) + 2
);
latestDelivery.setDate(
  latestDelivery.getDate() + Number(latestShippingDays) + 7
);

const orderShipsDateRange = formatDateRange(soonestShipping, latestShipping);
const deliveryDateRange = formatDateRange(soonestDelivery, latestDelivery);

document.getElementById('todays-date').textContent = month + ' ' + today;
document.getElementById('order-ships-date-range').textContent =
  orderShipsDateRange;
document.getElementById('order-delivered-date-range').textContent =
  deliveryDateRange;
document.getElementById('estimated-arrival').textContent = deliveryDateRange;
